<template lang="pug">
  .attach-file
    .attach-file__list
      .attach-file__item(
        v-if="localAttachments.length > 0"
        v-for="file in localAttachments"
      )
        .attached-file
          .button
            .button__icon
              img(src="@/assets/images/icons/doc.svg")
            a.button__text(
              v-if="readOnly"
              target="_blank"
              :href="file.file"
            ) {{file.name}}
            .button__text(
              v-else
            ) {{file.name}}
            button.attached-file__button-remove(
              v-if="!readOnly"
              type="button"
              @click="deleteFile($event, file.id)"
            )
              img(src="@/assets/images/icons/grey-cross.svg")
      .attach-file__item(
        v-if="!readOnly"
      )
        .input-file
          label.input-file__label
            .button
              .button__icon
                img(src="@/assets/images/icons/clip.svg")
              .button__text {{buttonText}}
            input.input-file__input(
              type="file"
              ref="attachFile"
              @change="onAddFile"
            )
            .input-file__outline
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AttachFile",
  props: {
    attachments: {
      type: Array,
      default: () => []
    },
    attachmentType: {
      type: String,
      default: ""
    },
    fieldname: {
      type: String,
      default: ""
    },
    keymonitor: {
      type: Function,
      default: () => {}
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    singleFile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      attachmentTypes: {
        image: "1",
        avatar: "2",
        passport: "3",
        file: "4",
        request: "5",
        medical: "6",
        child_passport: "7",
        inn: "8",
        snils: "9",
        order_docs_contract: "10",
        order_docs_invoice: "11",
        contact_attachments: "14",
        registration_documents_attachments: "17",
        school_certificate_attachments: "18"
      }
    };
  },
  computed: {
    localAttachments: {
      get() {
        return this.attachments;
      },
      set(value) {
        this.$emit("onChangeAttachments", {value, fieldname: this.fieldname});
      }
    },
    buttonText() {
      if (this.singleFile && this.localAttachments.length > 0) {
        return "Заменить файл";
      }
      return "Добавить файл";
    }
  },
  methods: {
    ...mapActions(["addAttachments"]),
    onAddFile(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      const type = this.attachmentTypes[this.attachmentType];
      if (!file || !type) {
        return;
      }
      formData.append("file", file);
      formData.append("attachment_type", type);
      this.addAttachments(formData).then(response => {
        file.id = response.data.id;
        file.url = response.data.url;
        if (this.singleFile) {
          this.localAttachments = [file];
        } else {
          this.localAttachments.push(file);
        }

        this.keymonitor();
      });
      e.target.value = "";
    },
    deleteFile(e, id) {
      e.preventDefault();
      this.localAttachments = this.localAttachments.filter(el => el.id !== id);
    }
  }
};
</script>
